import { createApp, h } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import vuetify from './plugins/vuetify';
// Panel-Stylesheet: MUSS hinter dem Vuetify-Plugin stehen, sonst gewinnen
// die mitgelieferten Vuetify-Stile gegen die Redesign-Grundlage.
import '../css/app.scss';
import { createPinia } from "pinia";
import resetStore from "./Stores/Plugins/reset-store";
import route from './plugins/route';
import Layout from "./Shared/AppLayout";
import jp from "jsonpath";
import axios from "axios";
import i18n, { attachLocaleHeader } from "./i18n";

window.jp = jp;

// Jeder axios-Request sagt dem Backend, in welcher Sprache es antworten soll.
// services/api.js hat eine eigene Instanz und hängt den Header dort an.
attachLocaleHeader(axios);


// axios configuration: globals/services/api.js
// laravel-echo configuration: globals/services/socket.js

export async function importPageComponent(name, pages, defaultLayout) {
    // eslint-disable-next-line no-restricted-syntax
    for (const path in pages) {
        if (path.endsWith(`${name.replaceAll('.', '/')}.vue`)) {
            const component = typeof pages[path] === 'function'
                ? await pages[path]()
                : pages[path];
            // Set default layout
            component.default.layout ??= defaultLayout;
            return component;
        }
    }

    throw new Error(`Page not found: ${name}`); // i18n-ignore: für Entwickler
}


InertiaProgress.init();
createInertiaApp({
    resolve: (name) => importPageComponent(name, import.meta.glob('./Pages/**/*.vue'), Layout),
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props)
        });

        const pinia = createPinia();
        pinia.use(resetStore);
        window.pinia = pinia;

        app.component("inertia-link", Link)
            .use(plugin)
            .use(pinia)
            .use(route)
            .use(vuetify)
            .use(i18n, { vuetify })
            .mount(el);
    },
});
